import React, { useMemo } from 'react';
import { Switch } from '@headlessui/react';
import { classNames } from '../utils';
import useDataService from '../hooks/useDataService';

export default function Toggle({ enabled, setEnabled, label = 'toggle' }) {
  const {
    ui: { isDarkMode },
  } = useDataService();

  const style = useMemo(() => {
    if (!isDarkMode) return {};
    return {
      '--tw-ring-offset-color': '#000',
    };
  }, [isDarkMode]);

  return (
    <Switch
      checked={enabled}
      onChange={setEnabled}
      className={classNames(
        enabled ? 'bg-orange-600' : 'bg-gray-200 dark:bg-gray-700',
        'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-orange-600 focus:ring-offset-2'
      )}
      style={style}
    >
      <span className="sr-only">{label}</span>
      <span
        aria-hidden="true"
        className={classNames(
          enabled ? 'translate-x-5' : 'translate-x-0',
          'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
        )}
      />
    </Switch>
  );
}
